import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { CodeModel } from 'src/models/common-code/CommonCode';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';
import { OperatorInfo } from 'src/models/operator-info/OperatorInfo';

/**
 * # Recruit
 *
 * Recruit을 설명하세요.
 */
export const Recruit = types
  .model('Recruit')
  .props({
    recruitSid: types.maybeNull(types.number), // 채용신청서 ID
    expCd: CodeModel, // 경력여부
    applyFieldCd: CodeModel, // 지원분야
    veteranCd: CodeModel, // 보훈여부
    disabledCd: CodeModel, // 장애여부
    nameKr: types.optional(types.string, ''), // 이름(한글)
    nameEn: types.optional(types.string, ''), // 이름(영문)
    desiredSalary: types.optional(types.maybeNull(types.number), 0), // 희망연봉
    genderTypeCd: CodeModel, // 성별
    email: types.optional(types.string, ''), // 이메일
    phone: types.optional(types.string, ''), // 전화번호
    emergencyContact: types.optional(types.string, ''), // 비상연락처
    birthDate: types.optional(types.string, ''), // 생년월일
    calendarTypeCd: CodeModel, // 양력/음력
    applySrc: types.optional(types.string, ''), // 지원경로
    address: types.optional(types.string, ''), // 주소
    resumeFilePath: types.optional(types.array(types.string), []), // 이력서 파일 경로
    applyDt: types.optional(types.number, 0), // 지원일
    viewYn: types.optional(types.boolean, false), // 확인여부
    recruitStatusCd: CodeModel, // 결과
    memo: types.optional(types.string, ''), // 메모(결과에 대한 메모)
    regUser: types.maybeNull(OperatorInfo),
    updUser: types.maybeNull(OperatorInfo),
    regDt: types.optional(types.maybeNull(types.number), 0),
    updDt: types.optional(types.maybeNull(types.number), 0),
  })
  .actions(withSetPropAction);

type TRecruit = Instance<typeof Recruit>;
type TRecruitSnapshot = SnapshotOut<typeof Recruit>;

export interface IRecruit extends TRecruit {}
export type TRecruitKeys = keyof TRecruitSnapshot & string;
export interface IRecruitSnapshot extends TRecruitSnapshot {}
export const createRecruit = () => types.optional(Recruit, {} as TRecruit);
